export default __webpack_public_path__ + "static/media/mu.27637fa8.jpg";